import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDU1qzRsTwv-eQxjiZhw8VTL6mL0F_icU8",
    authDomain: "ai-make.firebaseapp.com",  // 올바른 도메인으로 수정
    projectId: "centreor",                  // 이 값도 해당 프로젝트에 맞게 확인 필요
    storageBucket: "ai-make.appspot.com",   // 도메인과 맞추어 확인 필요
    messagingSenderId: "490480623904",
    appId: "1:490480623904:web:527c172b3549f945ed7745",
    measurementId: "G-Z23RNGPL20"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };